<template>
  <div id="patients">
    <div class="mb-2 wrrapper">
      <page-heading title="Patient List">
        <template #content>
          <div class="flex align-center">
            <Select
              class="mr-2"
              styles="expenses-select"
              :input="handleBranchChange"
              :options="brachData"
              :value="selectedBranch"
              :placeholder="
                brachData.length
                  ? brachData &&
                    brachData.find(item => item.key == userInfo.userBranchId)
                      .name
                  : ''
              "
            />
            <date-picker
              class="date-filter mr-2"
              labelFor="filterDate"
              :input="handleDate"
              :value="filterDate"
              :placeholder="datePlaceHolder"
            ></date-picker>
            <Select
              :options="['In-Queue', 'Processed']"
              placeholder="Filter by"
              styles="custom-sort mr-2"
              :input="handleFilter"
              :value="selectedStatus"
            />
            <Select
              :options="servicesList"
              placeholder="Filter by services"
              styles="custom-sort mr-2"
              :input="handleServices"
              :loading="isLoading"
              :value="selectedService"
            />
          </div>
        </template>
      </page-heading>
      <div class="tabs-container mb-3">
        <div class="tabs">
          <div
            :class="['tab', { active: activeTab === 'today' }]"
            @click="setActiveTab('today')"
          >
            Today <span class="badge">{{ todayList.length }}</span>
          </div>
          <div
            :class="['tab', { active: activeTab === 'yesterday' }]"
            @click="setActiveTab('yesterday')"
          >
            Yesterday <span class="badge">{{ yesterdayList.length }}</span>
          </div>
        </div>
        <div class="tab-content">
          <data-table
            v-if="activeTab === 'today'"
            :cols="columns"
            :rows="todayList"
            :loading="loading"
            :enable-sort-caching="true"
          >
            <template slot="action" slot-scope="{ actions }">
              <div class="patient-process">
                <router-link
                  :to="`/patients/${actions.id}`"
                  v-if="actions.historyStatus == 1"
                  >{{
                    actions.historyStatus == 1
                      ? "Go →"
                      : actions.historyStatus == 4
                      ? "Canceled"
                      : "Process →"
                  }}</router-link
                >
                <a
                  v-else
                  :class="actions.historyStatus == 4 ? 'canceled' : ''"
                  href="#"
                  @click="handlePatinetId(actions)"
                  >{{
                    actions.historyStatus == 1
                      ? "Go →"
                      : actions.historyStatus == 4
                      ? "Canceled"
                      : "Process →"
                  }}</a
                >
              </div>
            </template>
          </data-table>
          <data-table
            v-if="activeTab === 'yesterday'"
            :cols="columns"
            :rows="yesterdayList"
            :loading="loading"
            :enable-sort-caching="true"
          >
            <template slot="action" slot-scope="{ actions }">
              <div class="patient-process">
                <router-link
                  :to="`/patients/${actions.id}`"
                  v-if="actions.historyStatus == 1"
                  >{{
                    actions.historyStatus == 1
                      ? "Go →"
                      : actions.historyStatus == 4
                      ? "Canceled"
                      : "Process →"
                  }}</router-link
                >
                <a
                  v-else
                  :class="actions.historyStatus == 4 ? 'canceled' : ''"
                  href="#"
                  @click="handlePatinetId(actions)"
                  >{{
                    actions.historyStatus == 1
                      ? "Go →"
                      : actions.historyStatus == 4
                      ? "Canceled"
                      : "Process →"
                  }}</a
                >
              </div>
            </template>
          </data-table>
        </div>
      </div>
    </div>
    <ConfirmDialog
      name="confirmModal"
      title="Process patient"
      message="Are you sure you want to process this patient?"
      confirm-text="Yes, process"
      cancel-text="Cancel"
      @confirm="handleSave"
      @cancel="handleCancel"
    />
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
// import Input from "@/components/Input";
import Select from "@/components/Select";
import DatePicker from "../../../components/Datepicker";
import ConfirmDialog from "@/components/ConfirmDialog";
import { mapGetters, mapActions } from "vuex";
import { formatedDate } from "@/utils/helpers";
import moment from "moment";
import { api } from "@/axios";
import { permissionsMiddleWare } from "../../../utils/permissionsMiddleWare";
import { syncRouteQuery } from "@/utils/urlQueryFilters";
export default {
  components: {
    DataTable,
    DatePicker,
    Select,
    // Input,
    ConfirmDialog
  },
  data() {
    return {
      isLoading: false,
      datePlaceHolde: "",
      registrationId: "",
      filterData: {
        date: formatedDate()
      },
      id: "",
      historyData: {},
      datePlaceHolder: "",
      isAdmin: false,
      brachData: [],
      selectedBranch: null,
      selectedStatus: null,
      selectedService: null,
      filterDate: null,
      columns: [
        { column: "serial", label: "#", width: "60" },
        { column: "name", label: "Patient Name", sortable: true },
        { column: "mr_no", label: "Mr Number", sortable: true },
        { column: "service_name", label: "Service", sortable: true },
        { column: "created_at", label: "Created At", sortable: true },
        { column: "updated_at", label: "Performed At", sortable: true },
        { column: "reffered_to", label: "Referred to", sortable: true },
        { column: "createdbyname", label: "Created By", sortable: true },
        { column: "action", label: "Actions" }
      ],
      activeTab: "today"
    };
  },
  methods: {
    ...mapActions("receptionist", [
      "doctorsPatient",
      "doctorsPatientSearch",
      "cancelAppointment"
    ]),
    ...mapActions({ listHistory: "receptionist/listHistory" }),
    ...mapActions({ doctorList: "doctors/doctorList" }),
    ...mapActions("expenses", ["fetchBranch"]),
    getFilterQuery() {
      const query = { tab: this.activeTab };
      if (this.filterData.branchId) {
        query.branchId = this.filterData.branchId;
      }
      if (this.filterData.date) {
        query.date = this.filterData.date;
      }
      if (this.filterData.status) {
        query.status = this.filterData.status;
      }
      if (this.filterData.service) {
        query.service = this.filterData.service;
      }
      return query;
    },
    syncFiltersToUrl() {
      syncRouteQuery(this.$router, this.$route, this.getFilterQuery());
    },
    async applyFiltersFromUrl() {
      const { branchId, date, status, service, tab } = this.$route.query;

      if (tab === "today" || tab === "yesterday") {
        this.activeTab = tab;
      }

      if (branchId) {
        this.filterData.branchId = branchId;
        const branch = this.brachData.find(
          item => String(item.key) === String(branchId)
        );
        if (branch) {
          this.selectedBranch = branch;
        }
      } else {
        this.filterData.branchId = this.userInfo.userBranchId;
        const branch = this.brachData.find(
          item => String(item.key) === String(this.userInfo.userBranchId)
        );
        if (branch) {
          this.selectedBranch = branch;
        }
      }

      if (date) {
        this.filterData.date = date;
        this.datePlaceHolder = date;
        this.filterDate = date;
      } else {
        delete this.filterData.date;
      }

      if (status) {
        const statusNum = Number(status);
        this.filterData.status = statusNum;
        this.selectedStatus =
          statusNum === 1 ? "Processed" : statusNum === 2 ? "In-Queue" : null;
      }

      if (service) {
        this.filterData.service = service;
        const serviceOption = this.servicesList?.find(
          item => String(item.id) === String(service)
        );
        if (serviceOption) {
          this.selectedService = serviceOption;
        }
      }

      await this.doctorsPatient(this.filterData);
    },
    setActiveTab(tab) {
      this.activeTab = tab;
      this.syncFiltersToUrl();
    },
    handlePatinetId(actions) {
      this.historyData.id = actions.id;
      this.historyData.historyId = actions.historyId;
      if (actions.historyStatus == 2) {
        // this.cancelAppointment({ id: actions.id, payload });
      }
      if (actions.historyStatus == 1) {
        // this.$router.push({
        //   name: "PatientDetails",
        //   params: { id: actions.id },
        // });
      } else {
        this.$modal.show("confirmModal");
        this.id = actions.id;
        this.historyId = actions.historyId;
      }
    },
    async handleSave() {
      if (permissionsMiddleWare("Get Updated History")) {
        await this.listHistory(this.id);
        const selectedHistory = this.getHistory.find(
          item => item.id === this.historyId
        );
        const usersId = this.userInfo && this.userInfo?.id;
        const payload = {
          status: 1,
          userId: usersId,
          historyId: this.historyData.historyId
        };
        if (selectedHistory.status !== 4 && selectedHistory.status !== 7) {
          await this.cancelAppointment({
            id: this.historyData.id,
            payload
          }).then(() => {
            this.$router.push({
              name: "PatientDetails",
              params: { id: this.id }
            });
          });
          api
            .get(`/history/history-update/${this?.historyId}`)
            .then(res => {
              if (res?.data?.result?.affected === 1) {
                this.$toasted
                  .show("Status changed successfully")
                  .goAway("3000");
              } else {
                this.$toasted
                  .show("Status changed successfully")
                  .goAway("3000");
              }
            })
            .catch(() => {
              this.$toasted.show("Status didn't changed").goAway("3000");
            });
          this.$modal.hide("confirmModal");
        } else {
          this.$modal.hide("confirmModal");
          this.doctorsPatient(this.filterData);
          this.$toasted
            .info("This appointment has been already canceled")
            .goAway("3000");
        }
      } else {
        this.$toasted.info(
          "This action cannot be performed by you due to insufficient authorization. Action : Get Updated History",
          { duration: 3000 }
        );
      }
    },
    handleCancel() {
      this.$modal.hide("confirmModal");
      this.id = "";
    },
    handleSearch() {
      this.doctorsPatientSearch(this.registrationId);
    },
    handleServices(val) {
      if (val) {
        if (!this.filterData.date) {
          this.filterData.date = formatedDate(moment());
        }
        this.filterData.service = val.id;
        this.selectedService = val;
        this.filterDate = this.filterData.date;
        this.datePlaceHolder = this.filterData.date;
        this.doctorsPatient(this.filterData);
      } else {
        delete this.filterData.service;
        this.selectedService = null;
        this.doctorsPatient(this.filterData);
      }
      this.syncFiltersToUrl();
    },
    handleDate(val) {
      this.filterData.date = formatedDate(val);
      this.filterDate = this.filterData.date;
      this.datePlaceHolder = this.filterData.date;
      this.doctorsPatient(this.filterData);
      this.syncFiltersToUrl();
    },
    handleReset() {
      this.doctorsPatient(this.filterData).then(() => {
        this.registrationId = "";
      });
    },
    handleFilter(val) {
      if (!this.filterData.date) {
        this.filterData.date = formatedDate(moment());
        this.filterDate = this.filterData.date;
        this.datePlaceHolder = this.filterData.date;
      }

      if (val) {
        if (val == "Processed") {
          this.filterData.status = 1;
          this.selectedStatus = "Processed";
          this.doctorsPatient(this.filterData);
        } else if (val == "In-Queue") {
          this.filterData.status = 2;
          this.selectedStatus = "In-Queue";
          this.doctorsPatient(this.filterData);
        } else {
          this.filterData.status = null;
          this.selectedStatus = null;
          this.doctorsPatient(this.filterData);
        }
      } else {
        delete this.filterData.status;
        this.selectedStatus = null;
        delete this.filterData.service;
        this.selectedService = null;
        this.doctorsPatient(this.filterData);
      }
      this.syncFiltersToUrl();
    },
    handleBranchChange(val) {
      if (val && val != null) {
        this.filterData.branchId = val.key;
        this.selectedBranch = val;
        this.doctorsPatient(this.filterData);
      }
      if (val === null) {
        this.doctorsPatient(this.filterData);
      }
      this.syncFiltersToUrl();
    }
  },
  computed: {
    ...mapGetters({
      doctorPatients: "receptionist/doctorPatients",
      listDoctors: "doctors/listDoctors",
      userInfo: "auth/userInfo",
      loading: "loading",
      role: "auth/role",
      fetchUserBranch: "expenses/fetchUserBranch",
      getHistory: "receptionist/getHistory"
    }),
    ...mapGetters({ listDoctors: "doctors/listDoctors" }),
    servicesList() {
      return (
        this.listDoctors &&
        this.listDoctors.map(item => ({
          id: item.id,
          name: item.name
        }))
      );
    },
    todayList() {
      const item = this.doctorPatients || [];
      const filterArr = item.filter(item => {
        const date = formatedDate(item.created_at);
        return moment(date).isSame(formatedDate());
      });
      return filterArr;
    },
    yesterdayList() {
      const item = this.doctorPatients || [];
      const filterArr = item.filter(item => {
        const date = formatedDate(item.created_at);
        return moment(date).isBefore(formatedDate());
      });
      return filterArr;
    }
  },
  async mounted() {
    this.datePlaceHolder = formatedDate(moment());
    this.isLoading = true;
    await this.fetchBranch();
    this.isAdmin = this.role.some(({ name }) => name === "admin");
    await this.fetchUserBranch?.map(elem => {
      this.brachData.push({ name: elem.name, key: elem.id });
    });
    try {
      await this.doctorList("servicehead");
      await this.applyFiltersFromUrl();
    } catch (error) {
      // keep page usable if doctor list fails
    } finally {
      this.isLoading = false;
      setTimeout(() => {
        this.$store.dispatch("auth/userLoginProgress", false);
      }, 3000);
    }
  }
};
</script>

<style>
#patients .footer {
  margin-right: 30px !important;
}

.date-filter .custom-datepicker {
  margin-top: 0;
}

.patient-process {
  width: 7rem !important;
}

.patient-process a {
  background: #777;
  padding: 0.33rem 0.7rem;
  border-radius: 5px;
  color: #fff;
}

.patient-process a:hover {
  background: #696666;
}

.canceled {
  pointer-events: none;
  opacity: 0.9;
}

.tabs-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 1rem 0 0 0;
}

.tabs {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 1rem;
}

.tab {
  padding: 0.75rem 2rem;
  cursor: pointer;
  font-weight: 600;
  color: #888;
  border-bottom: 2px solid transparent;
  transition: color 0.2s, border-bottom 0.2s;
  position: relative;
}

.tab.active {
  color: #1976d2;
  border-bottom: 2px solid #1976d2;
  background: #f7faff;
}

.badge {
  background: #1976d2;
  color: #fff;
  border-radius: 12px;
  padding: 0 8px;
  font-size: 0.85em;
  margin-left: 0.5em;
}

.tab-content {
  padding: 0.5rem 0;
}
</style>
